<template>
	<v-container>
		<slot name='layout' :image='imageSrc' :message='message'>
			<v-row>
				<v-col cols='3'>
					<v-img contain :src='imageSrc'></v-img>
				</v-col>
				<v-col cols='6' align-self='center'>
			<span id='waiting-message' class='text-h2'>
				 {{ message }}
			</span>
				</v-col>
				<v-col cols='3'>
					<v-img contain :src='imageSrc'></v-img>
				</v-col>
			</v-row>
		</slot>
	</v-container>
</template>

<script>
export default {
	name: 'WaitingForStreaming',
	props: {
		message: {
			type: String,
			required: false,
			default: 'Waiting for streaming...'
		},
		imageSrc: {
			type: String,
			required: true
		}
	}
};
</script>

<style scoped>
@keyframes blink {
	0% {
		color: black;
	}
	50% {
		color: grey;
	}
	100% {
		color: black;
	}
}

span, .waiting-message {
	transition: background-color 0.5s ease-in-out;
	animation: blink normal 1.5s infinite ease-in-out;
}
</style>
